module.exports = __webpack_public_path__ + "files/Resume_TonyWongSiuFai_2019.0a469286.pdf";